import { KYMW4100Model } from '../kymw4100.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * 統一企画点検リスト出力（生協間）クラス
 *
 * @export OutputGoodsLayoutInspectListService
 * @class OutputGoodsLayoutInspectListService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class OutputGoodsLayoutInspectListService extends PlessJsonResponderSub<any> {

  // VO
  private vo: {
    orderCode: '',
    mediumType: '',
    startPageNum: '',
    endPageNum: '',
    inspectObject: '',
    mediumTypeTo: '',
    coopCodeList: []
  };
  // 処理に使用するModel
  private model: KYMW4100Model;
  private successFunc: Function;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof OutputGoodsLayoutInspectListService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      search: {
        outputGoodsLayoutInspectList: {
          condition: {
            OrderCode: this.vo.orderCode,
            MediumType: this.vo.mediumType,
            StartPageNum: this.vo.startPageNum,
            EndPageNum: this.vo.endPageNum
          },
          combination: this.vo.coopCodeList.map(coopCode => {
            return {
              condition: {
                CoopCode: coopCode
              }
            }
          })
        }
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param model 処理に使用するモデル
   * @param vo vo
   * @param successFunc 成功時に実行される処理
   * @memberof OutputGoodsLayoutInspectListService
   */
  execute(model: KYMW4100Model, vo: any, successFunc: Function = null): void {
    this.model = model;
    this.vo = vo;
    this.successFunc = successFunc;
    this.send('KYMW41outputGoodsLayoutInspectList', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof OutputGoodsLayoutInspectListService
   */
  success(data: any): void {

    // レスポンスのファイルパスをマネージに保存
    this.model.updateFileUrl(data);
    if (this.successFunc !== null) {
      this.successFunc(data);
    }
  }
}
